export const setFollowedByYouInFTF = (
    FTFContent: any[],
    userFollowedOrganizerIds: string[],
) =>
    FTFContent.map((content) => {
        const processedArticles = content.organizer_articles.map(
            (article: { id: string }) => {
                if (userFollowedOrganizerIds.includes(article.id)) {
                    // eslint-disable-next-line camelcase, no-param-reassign
                    return { ...article, followed_by_you: true };
                }
                return article;
            },
        );

        return {
            ...content,
            // eslint-disable-next-line camelcase, no-param-reassign
            organizer_articles: processedArticles,
        };
    });
